import useClickOut from 'hooks/useClickOut'
import moment from 'moment'
import { useRef, useState } from 'react'

import styles from '../MontlyRevenue.module.scss'

const YearPicker = ({ firstYear, secondYear, minimumAvailableYear, setYears }) => {
  const [selectedFirstYear, setSelectedFirstYear] = useState()
  const [selectedSecondYear, setSelectedSecondYear] = useState()

  const [isFirstYearPickerVisible, setisFirstYearPickerVisible] = useState(false)
  const [isSecondYearPickerVisible, setisSecondYearPickerVisible] = useState(false)

  function handleClickPicker() {
    if (!isFirstYearPickerVisible && !isSecondYearPickerVisible) {
      setisFirstYearPickerVisible(true)
    }
  }

  function handlePickFirstYear(year) {
    setSelectedFirstYear(year)
    setisFirstYearPickerVisible(false)
    setisSecondYearPickerVisible(true)
  }

  function handlePickSecondYear(secondYear) {
    setSelectedSecondYear(secondYear)
    setisSecondYearPickerVisible(false)
    setYears(selectedFirstYear, secondYear)
  }

  const firstYearPickerRef = useRef()

  useClickOut(firstYearPickerRef, () => {
    if (isFirstYearPickerVisible) {
      setisFirstYearPickerVisible(false)
      setSelectedFirstYear()
      setSelectedSecondYear()
    }
  })

  const secondYearPickerRef = useRef()

  useClickOut(secondYearPickerRef, () => {
    if (isSecondYearPickerVisible) {
      setisSecondYearPickerVisible(false)
      setSelectedFirstYear()
      setSelectedSecondYear()
    }
  })

  return (
    <div className={styles.yearVersusPicker}>
      <div onClick={handleClickPicker}>
        {!selectedFirstYear && !selectedSecondYear && (
          <>
            {' '}
            {firstYear} <span className={styles.versus}>vs</span>
            {secondYear}
          </>
        )}
        {selectedFirstYear && !selectedSecondYear && (
          <>
            {' '}
            {selectedFirstYear} <span className={styles.versus}>vs</span>-
          </>
        )}
        {selectedFirstYear && selectedSecondYear && (
          <>
            {selectedFirstYear} <span className={styles.versus}>vs</span>
            {selectedSecondYear}
          </>
        )}
      </div>
      {isFirstYearPickerVisible && (
        <div className={styles.yearPicker} ref={firstYearPickerRef}>
          <p className={styles.yearPickerLabel}>Select first year</p>
          {Array(Number(moment().format('YYYY')) - minimumAvailableYear)
            .fill(Number(moment().format('YYYY')))
            .map((year, index) => year - index - 1)
            .map(year => (
              <button
                key={year}
                className={styles.yearPickerButton}
                onClick={() => handlePickFirstYear(year)}
              >
                {year}
              </button>
            ))}
        </div>
      )}
      {isSecondYearPickerVisible && (
        <div className={styles.yearPicker} ref={secondYearPickerRef}>
          <p className={styles.yearPickerLabel}>Select second year</p>
          {Array(Number(moment().format('YYYY')) - selectedFirstYear)
            .fill(Number(moment().format('YYYY')))
            .map((year, index) => year - index)
            .map(year => (
              <button
                key={year}
                className={styles.yearPickerButton}
                onClick={() => handlePickSecondYear(year)}
              >
                {year}
              </button>
            ))}
        </div>
      )}
    </div>
  )
}

export default YearPicker
